import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';
import { singleEmailValidation } from "@/services/misc/functions/ValidationFunctions";

export default class CreateSelfSignedCertificateForm {
  public websiteId: number = 0;

  public altNames: string[] = [];

  public email?: string = '';

  public vhostAliases: boolean = false;

  public autoRenew: boolean = false;

  public rules: { [key: string]: FormValidationFunction[] } = {
    websiteId: [
      (v: number) => v <= 0 || 'Invalid website id',
    ],
    email: [
      ...singleEmailValidation(),
    ],
  };
}
